import type { CSSProperties } from "react";

// Vite inlines small SVGs as data: URLs that contain single quotes. An
// unquoted url() cannot hold a quote, so the browser drops the whole mask.
export function maskImageStyle(url: string): CSSProperties {
  const mask = `url("${url}") center / contain no-repeat`;
  return { mask, WebkitMask: mask };
}
